import styled from 'styled-components'
import Button from '~components/dumbs/Button'

export const Timer = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  font-size: ${({ theme }) => theme.font.size.m2};
  line-height: 32px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.neutral.text.weak};
`

export const ButtonsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.km4};
  text-align: -webkit-center;
`

export const ButtonWithMargin = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`
